import * as React from 'react';
import autobind from "autobind-decorator";

import { ProductServiceTypeDataService } from "./product-service-type-editor.data";
import { ProductServiceTypeEditorView } from "./product-service-type-editor.view";

interface ProductServiceTypeEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: ProductServiceTypeSummary) => void;
    setBusy(isBusy: boolean);
    label?: string;
    categoryId?: number;
    required?: boolean;
}

export class ProductServiceTypeEditorController extends React.Component<ProductServiceTypeEditorControllerProps, any> {
    protected dataService: ProductServiceTypeDataService;

    constructor(props) {
        super(props);
        this.dataService = ProductServiceTypeDataService.make();
    }

    @autobind
    protected productServiceTypeQuery(q?: string): Promise<QueryResult<ProductServiceTypeSummary>> {
        return new Promise<QueryResult<ProductServiceTypeSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.dataService.addFilter('isDeleted', 'eq', false);
            this.dataService.addSorting('id', 'asc', true);
            this.dataService.searchKeywords = q;
            this.dataService
                .load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.dataService.count
                    });
                });
        });
    }

    render() {
        return (
            <ProductServiceTypeEditorView
                required={this.props.required}
                productServiceTypeRequest={{ query: this.productServiceTypeQuery, dataSet: this.dataService }}
                label={this.props.label}
                onChanged={this.props.onChanged}
                value={this.props.value}
                mode={this.props.mode}
                categoryId={this.props.categoryId}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/product-service-types/parts/product-service-type-editor.controller.tsx